import React from "react";
import { withFocusable } from "../../services/visualLibraryService";
import { withAppState } from "../../state";
import Logo from "../../components/Logo";
import { i18n } from "../../services/i18nService";
import {
  BuyAssetPageStyled,
  BodySection,
  FooterTextStyled,
  HeadingBorder,
  FooterSections,
  BorderDiv,
  BuyBrandsContainer,
  LogoStyled,
  HeadingStyled,
  HeadingStyle,
  StepContainer,
  StepNumber,
  StepText,
  PriceStyled,
  DetailsContainerStyle,
  QrCodeStyle,
  ButtonModalStyled,
  ButtonModelWrapper,
  ImageWrapper,
  PriceContainer
} from "./styles/Styled";
import { Loading } from "../../services/visualLibraryService";
import { getOneTimeAuthToken, getWebPortalURL } from "../../services/tvodService";
import {
  getBuyBrandsInfoObj,
  isBaseContent,
  getBrandsName,
  isBaseContentBrand,
  getBuyBrandsInfoObjChampionsTrophy,
  CHAMPIONS_TROPHY
} from "../../utils/tvodUtils.js";
import { getSdk } from "../../services/sdkService";
import QRCodeReact from "react-qr-code";
import { config } from "../../config/config";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { base64Encode } from "../../utils/encodingUtil";
import { getCurrentProfile } from "../../services/multipleProfilesService";
import { getLocaleFromLocalCache } from "../../services/localeCacheService.js";

const ButtonModalFocus = withFocusable(ButtonModalStyled);
const finishFocusPath = "buttonFinishBuyBrands";
const refreshFocusPath = "buttonRefreshBuyBrands";

class BuyBrands extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: (this.props.location && this.props.location.state && this.props.location.state.data) || {},
      loading: false,
      sectionLoaded: false,
      qrCodeURL: "",
      price: "",
      brandsName: "",
      brandsImage: "",
      infoObj: null
    };
    this.pollingFinishTime = new Date(Date.now() + 5 * 60 * 1000); // the next five minutes
    this.onBack = this.onBack.bind(this);
    this.backUserWithUpdatedData = this.backUserWithUpdatedData.bind(this);
    this.refreshQRCode = this.refreshQRCode.bind(this);
  }

  async pollingTime() {
    const { data } = this.state;
    const pollingIntervalTime = config.get().buyAssetOrBrand && config.get().buyAssetOrBrand.pollingTime;

    this.timer = setInterval(async () => {
      try {
        const currentDateTime = new Date(Date.now());
        if (currentDateTime > this.pollingFinishTime) {
          clearInterval(this.timer);
          this.backUserWithUpdatedData();
        } else {
          const result = await getSdk().userManager.get({ avoidCache: true });
          const purchasedAddOns = result.settings.addons || [];

          let isThisAddOnPurchased = purchasedAddOns.filter(
            addon =>
              addon.name === (data?.isCTStandalone ? CHAMPIONS_TROPHY : data.addonContent) &&
              addon.status.toLowerCase() === "active"
          );
          isThisAddOnPurchased = isThisAddOnPurchased.length > 0 ? isThisAddOnPurchased[0] : null;

          if (
            (isBaseContentBrand(data.addonContent) || isBaseContent(data.addonContent)) &&
            result.settings.accountStatus.toLowerCase() === "active"
          ) {
            isThisAddOnPurchased = true;
          }

          if (isThisAddOnPurchased) {
            clearInterval(this.timer);
            this.backUserWithUpdatedData(result);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }, pollingIntervalTime);
  }

  async getQRCode(infoObj) {
    const token = await getOneTimeAuthToken();
    const locale = getLocaleFromLocalCache();

    let urlQueryParams = `token=${token}`;
    const profile = await getCurrentProfile();
    const profileName = profile?.profileName;
    const profileId = profile?.profileId;
    urlQueryParams = `${urlQueryParams}&profileId=${profileId}&profileName=${profileName}`;
    const encodedURLPart = base64Encode(urlQueryParams);

    const subscriptionName = infoObj?.CTAddOnData?.isCTStandalone
      ? infoObj?.CTAddOnData?.name
      : infoObj.subscriptionName;

    return infoObj.isToShowMultipleSubscriptions
      ? `${getWebPortalURL()}/${locale}/settings/tvpayment/choosesubscription?key=${encodedURLPart}`
      : `${getWebPortalURL()}/${locale}/settings/tvpayment/choosesubscription/${subscriptionName}?key=${encodedURLPart}`;
  }

  async componentDidMount() {
    this.props.onRef && this.props.onRef(this); // to connect this page to App.js for further use
    this.setState({ loading: true, sectionLoaded: true });
    const { data } = this.state;
    const {
      applicationState: { addons }
    } = this.props;
    this.props.resumeNavigation();
    const infoObj = data?.isChampionsTrophyAddOn
      ? getBuyBrandsInfoObjChampionsTrophy(addons, data.addonContent)
      : getBuyBrandsInfoObj(addons, data.addonContent, data.childAddon && data.childAddon);

    const qrCodeURL = await this.getQRCode(infoObj);
    console.log("==> ~ BuyBrands ~ componentDidMount ~ qrCodeURL:", qrCodeURL);

    const brandsName = getBrandsName(
      addons,
      infoObj.action !== "activate" ? infoObj.subscriptionName : data.addonContent
    );
    this.setState({
      infoObj: infoObj,
      qrCodeURL: qrCodeURL,
      loading: false,
      sectionLoaded: false,
      brandsName: brandsName.name,
      brandsImage: brandsName?.configuration.logoDefaultPNG,
      paymentPlans: infoObj.paymentPlans,
      isMonthlyPlan: infoObj.isMonthlyPlan
    });
    await this.pollingTime();
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  async enterHandler() {
    await this.onBack();
  }

  async onBack() {
    this.backUserWithUpdatedData();
    return true;
  }

  async backUserWithUpdatedData(userData = null) {
    const currentProfile = await getCurrentProfile();
    this.setState({ loading: true }, async () => {
      const { stateActions, history } = this.props;
      userData && (await stateActions.userLoggedIn(userData, false, currentProfile));
      const backDestination = history?.location?.state?.data.backDestination;
      const backDestinationPathname = backDestination?.pathname || backDestination;
      // Special Case for FVOD
      const playerReferrerPath = localStorage.getItem("playerReferrer");
      if (backDestinationPathname) {
        history.replace(backDestinationPathname);
      } else if (playerReferrerPath) {
        history.replace(playerReferrerPath);
      } else {
        history.goBack();
      }
    });
  }

  async refreshQRCode(infoObj) {
    clearInterval(this.timer);
    this.setState({ sectionLoaded: true });
    let qrCodeURL = await this.getQRCode(infoObj);

    this.setState({
      qrCodeURL: qrCodeURL,
      loading: false,
      sectionLoaded: false
    });

    await this.pollingTime();
  }

  render() {
    const { loading, brandsImage, infoObj, paymentPlans, brandsName, data, isMonthlyPlan } = this.state;

    const {
      applicationState: { userLocale }
    } = this.props;
    const championsTrophyPrice = infoObj?.CTAddOnData?.isCTStandalone
      ? infoObj?.price
      : infoObj?.CTAddOnData?.CTPrices?.monthlyPrice;
    return loading ? (
      <Loading overlay />
    ) : (
      <>
        <BuyAssetPageStyled
          background={
            userLocale === "ar"
              ? `https://starzplay-img-prod-ssl.akamaized.net/prd-peg-data/default/images/background/subscription-activation-sheets/${brandsName}-tv-rtl.jpg`
              : `https://starzplay-img-prod-ssl.akamaized.net/prd-peg-data/default/images/background/subscription-activation-sheets/${brandsName}-tv-ltr.jpg`
          }
        >
          <LogoStyled>
            <Logo />
          </LogoStyled>
          <BuyBrandsContainer>
            <HeadingStyle>
              <ImageWrapper
                src={
                  infoObj?.CTAddOnData?.isCTStandalone
                    ? infoObj?.logoImage
                    : (infoObj && infoObj.logoCoupledImage) || brandsImage
                }
                alt="Logo"
              />
              <PriceContainer>
                <HeadingStyled
                  rank={1}
                  text={
                    infoObj && infoObj.isBilledOnce
                      ? i18n.get("pages.buyBrands.billedOnce")
                      : (paymentPlans && paymentPlans.length === 1) ||
                        infoObj?.action === "switch" ||
                        data?.isChampionsTrophyAddOn
                      ? i18n.get("pages.buyBrands.getItFor")
                      : isMonthlyPlan
                      ? i18n.get("pages.buyBrands.getItFor")
                      : paymentPlans && i18n.get("pages.buyBrands.startFrom")
                  }
                  size="medium"
                />
                <PriceStyled
                  rank={1}
                  text={
                    data?.isChampionsTrophyAddOn && championsTrophyPrice
                      ? infoObj?.CTAddOnData?.isCTStandalone
                        ? infoObj?.isRecurringPlan
                          ? i18n.get("pages.buyBrands.oneTimePaymentRecurring", championsTrophyPrice)
                          : i18n.get("pages.buyBrands.oneTimePayment", championsTrophyPrice)
                        : `${i18n.get(
                            "pages.buyBrands.amount",
                            infoObj && infoObj.price,
                            infoObj && infoObj.buyBrandsPackageTimeUnit
                          )} ${i18n.get(
                            `pages.layout.activationBanner.parent+addon.additionalIn`,
                            championsTrophyPrice
                          )}`
                      : i18n.get(
                          "pages.buyBrands.amount",
                          infoObj && infoObj.price,
                          infoObj && infoObj.buyBrandsPackageTimeUnit
                        )
                  }
                  size="medium"
                />
              </PriceContainer>
            </HeadingStyle>
            <HeadingBorder />
            <BodySection>
              <DetailsContainerStyle>
                <StepContainer>
                  <StepNumber>1</StepNumber>
                  <StepText rank="3" text={i18n.get("pages.buyBrands.step1")} size="medium" />
                  <BorderDiv />
                </StepContainer>
                <StepContainer>
                  <StepNumber>2</StepNumber>
                  <StepText rank="3" text={i18n.get("pages.buyBrands.step2")} size="medium" />
                  <BorderDiv />
                </StepContainer>
                <StepContainer>
                  <StepNumber>3</StepNumber>
                  <StepText rank="3" text={i18n.get("pages.buyBrands.step3")} size="medium" />
                </StepContainer>
              </DetailsContainerStyle>
              {!this.state.sectionLoaded ? (
                <QrCodeStyle>
                  <QRCodeReact value={this.state.qrCodeURL} size={349} />
                </QrCodeStyle>
              ) : (
                <Loading overlay opacity="0" />
              )}
            </BodySection>
            <HeadingBorder />
            <FooterSections>
              <FooterTextStyled rank="3" text={i18n.get("pages.buyasset.qrRefresh")} size="small" />
              <ButtonModelWrapper>
                <ButtonModalFocus
                  label={i18n.get("pages.buyasset.refresh").toUpperCase()}
                  focusPath={refreshFocusPath}
                  onEnterPress={() => this.refreshQRCode(infoObj)}
                  onMouseUp={() => this.refreshQRCode(infoObj)}
                  onClick={() => this.refreshQRCode(infoObj)}
                  size="medium"
                />
              </ButtonModelWrapper>
            </FooterSections>
            <HeadingBorder />
            <FooterSections>
              <FooterTextStyled rank="3" text={i18n.get("pages.buyasset.cancelPage")} size="small" />
              <ButtonModelWrapper>
                <ButtonModalFocus
                  label={i18n.get("pages.buyasset.done").toUpperCase()}
                  focusPath={finishFocusPath}
                  onEnterPress={() => this.enterHandler()}
                  onMouseUp={() => this.enterHandler()}
                  onClick={() => this.enterHandler()}
                  size="medium"
                />
              </ButtonModelWrapper>
            </FooterSections>
          </BuyBrandsContainer>
        </BuyAssetPageStyled>
      </>
    );
  }
}

const Component = withAppState(withSubtheme(BuyBrands));
Component.defaultFocusPath = finishFocusPath;
export default Component;
